var map = {
  "./mobile/index": [
    "61259",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "6937",
    "38154",
    "17189",
    "4253",
    "10439",
    "43821"
  ],
  "./desktop/index.js": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "47387",
    "3199",
    "88565",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "32014",
    "4253",
    "70949",
    "48027"
  ],
  "./desktop/index": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "47387",
    "3199",
    "88565",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "32014",
    "4253",
    "70949",
    "48027"
  ],
  "./mobile/index.js": [
    "61259",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "6937",
    "38154",
    "17189",
    "4253",
    "10439",
    "43821"
  ],
  "./mobile/LatestNews": [
    "76439",
    9,
    "9598",
    "47387",
    "88565",
    "34334"
  ],
  "./mobile": [
    "61259",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "6937",
    "38154",
    "17189",
    "4253",
    "10439",
    "43821"
  ],
  "./mobile/LatestNews.scss": [
    "22627",
    7,
    "88427"
  ],
  "./desktop": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "47387",
    "3199",
    "88565",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "32014",
    "4253",
    "70949",
    "48027"
  ],
  "./desktop/": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "47387",
    "3199",
    "88565",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "32014",
    "4253",
    "70949",
    "48027"
  ],
  "./desktop/LatestNews.scss": [
    "44021",
    7,
    "67209"
  ],
  "./desktop/LatestNews.js": [
    "68747",
    9,
    "9598",
    "47387",
    "88565",
    "32014",
    "87376"
  ],
  "./mobile/": [
    "61259",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "6937",
    "38154",
    "17189",
    "4253",
    "10439",
    "43821"
  ],
  "./desktop/LatestNews": [
    "68747",
    9,
    "9598",
    "47387",
    "88565",
    "32014",
    "87376"
  ],
  "./mobile/LatestNews.js": [
    "76439",
    9,
    "9598",
    "47387",
    "88565",
    "34334"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 59134;
module.exports = __rspack_async_context;
